import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { GetChartShapesList } from '../../store/NTX/Reports/ReportShape/reportShapeSlice';
import { useTranslation } from 'react-i18next';

const useGetChartShapesList = () => {
  const dispatch = useAppDispatch();

  const { i18n } = useTranslation();

  useEffect(() => {
    if (ChartShapesList?.length === 0) {
      dispatch(GetChartShapesList());
    }
  }, []);

  const { ChartShapesList, loading, error } = useAppSelector(state => state.ReportShape);
  const ChartShapesOptions = ChartShapesList?.map(item => ({
    value: item.id,
    label: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <i className={item.icon + ' text-theme'}></i>
        {i18n.language === 'ar' ? item.name2 : item.name}
      </div>
    ),
    // label: i18n.language === 'ar' ? item.name2 : item.name,
    // icon: item.icon,
    maxKpi: item.maxKpi
  }));

  return { ChartShapesList, loading, error, ChartShapesOptions };
};

export default useGetChartShapesList;
